export enum GalleryType {
  Photo = "Photo",
  Quote = "Quote",
  Image = "Image",
}
